import { useMutation } from "@tanstack/react-query";
import { supabaseClient } from "../utils/supabase";
import { useAuth } from "./useAuth";

type SendPhoneOtpResponse = { ok: true } | { ok: false; error: string; code: string };

export function useSendOtp() {
    return useMutation({
        mutationFn: async (phone: string) => {
            // Service-role edge function sends OTP for both new registrations and returning
            // participants, even when project-level SMS signups are disabled for anon clients.
            const { data, error } = await supabaseClient.functions.invoke<SendPhoneOtpResponse>(
                "public-send-phone-otp",
                { body: { phone } }
            );

            if (error) {
                throw new Error(error.message);
            }

            if (!data?.ok) {
                const err = new Error(data?.error ?? "Failed to send code");
                Object.assign(err, { code: data?.code });
                throw err;
            }

            return { phone };
        },
        onSuccess: ({ phone }) => {
            // Store the phone number in auth state for later use
            useAuth.getState().setPhone(phone);
        },
    });
}
